import { useState } from 'react';
import { Button, Card, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';

const previewTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif', 'bmp', 'svg'];

interface LeadEventAttachFileProps {
    fileName: string;
    fileIndex?: number;
    disabled?: boolean;
    delOnClick?: (index: number) => void;
    dataGallery?: string;
}

const LeadEventAttachFile = ({ fileName, fileIndex = 0, disabled = false, delOnClick, dataGallery }: LeadEventAttachFileProps) => {
    const { t } = useTranslation(['Leads']);
    let url = '';
    try {
        url = String(new URL(fileName));
    } catch (e) {
        console.error(e);
    }

    const pathname = new URL(url || 'http://localhost').pathname || '';
    const fileNameWithExt = decodeURIComponent(pathname.split('/').pop() || '');
    const extension = fileNameWithExt.split('.').pop()?.toLowerCase() || '';
    const [src, setSrc] = useState(`/imgs/fileTypes/${extension?.toLowerCase()}.png`);

    return (
        <li className="list-inline-item" style={{ maxWidth: '250px' }}>
            <Card className="p-1 my-1 text-truncate" style={{ borderRadius: '8px' }} title={fileNameWithExt}>
                <Card.Body className="text-truncate p-0 d-flex align-items-center">
                    <Image
                        className="rounded img-fluid me-1"
                        style={{ height: '24px', padding: '2px' }}
                        onError={() => setSrc('/imgs/fileTypes/unknown.png')}
                        src={src}
                    />
                    <span className="text-truncate fs-12" style={{ paddingRight: delOnClick ? '30px' : '10px' }}>
                        <a
                            className={dataGallery && previewTypes.includes(extension) ? 'glightbox' : ''}
                            target="_blank"
                            href={fileName}
                            data-gallery={dataGallery}
                            rel="noreferrer"
                        >
                            {fileNameWithExt}
                        </a>
                    </span>

                    <div
                        style={{
                            position: 'absolute',
                            right: '8px',
                            opacity: '0.8',
                        }}
                    >
                        {delOnClick && (
                            <Button
                                className="px-1 py-0"
                                variant="light-danger"
                                title={t('leadStatus.btnAttachDel')}
                                size="sm"
                                disabled={disabled}
                                onClick={() => delOnClick(fileIndex)}
                            >
                                <SolarIcon name="trash3" className="fs-12" />
                            </Button>
                        )}
                    </div>
                </Card.Body>
            </Card>
        </li>
    );
};

export default LeadEventAttachFile;
